import { Form, Modal, Select, Button, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { getDirectusClient } from '../../../lib/directus';
import { createItem, updateItem } from '@directus/sdk';
import { Input } from 'antd';
import { useSelector } from 'react-redux';

function Editar(props) {
  const [fielderror, setFielderror] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  
  // Obtener el rol y ID del usuario desde Redux
  const userRoleID = useSelector((state) => state?.userdata?.role?.name);
  const userId = useSelector((state) => state?.userdata?.id);
    
  const onFinish = async (r) => {
    setLoading(true);
    const directus = await getDirectusClient();
    
    await directus
      .request(
        updateItem("rutas", props.data.id, {
          coordinador: {
            create: [
              {
                rutas_id: "+",
                coordinador_id: {
                  // Si el usuario es coordinador, usar su ID, sino usar el seleccionado
                  id: userRoleID.includes("coordinador") ? userId : r?.coordinador,
                },
              },
            ],
            update: [],
            delete: [
              props.data?.coordinador ? props.data?.coordinador[0]?.id : null,
            ],
          },
          nombre: r?.nombre,
          descripcion: r?.descripcion,
        })
      )
      .then((res) => {
        props.handleCanceleditar();
        setError("")
        props.onSuccess();
        setLoading(false);
      })
      .catch((er) => {
        console.log(er.errors[0].extensions.field);
        setFielderror(er.errors[0].extensions.field);
        setError(true);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoading(false);
  };
  
  useEffect(() => {
    form.setFieldValue("nombre", props?.data?.nombre);
    form.setFieldValue("descripcion", props?.data?.descripcion);
    // Solo establecer el coordinador si el usuario no es coordinador
    if (!userRoleID.includes("coordinador")) {
      form.setFieldValue(
        "coordinador",
        props?.data?.coordinador ? props?.data?.coordinador[0]?.coordinador_id?.id : null
      );
    }
  }, [props?.data])

  return (
    <Modal
      title="Editar Ruta"
      open={props.openmodaleditar}
      onOk={false}
      onCancel={props.handleCanceleditar}
      footer={null}
    >
      {error ? (
        <p style={{ color: "red" }}>
          El campo {fielderror} ya existe en el sistema{" "}
        </p>
      ) : null}
      <Spin spinning={loading}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="nombre"
            name="nombre"
            rules={[{ required: true, message: "ingresar nombre" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="descripcion"
            name="descripcion"
            rules={[{ required: true, message: "ingresar descripcion" }]}
          >
            <Input />
          </Form.Item>

          {/* Solo mostrar el selector de coordinador si el usuario no es coordinador */}
          {!userRoleID.includes("coordinador") && (
            <Form.Item
              label="coordinador"
              name="coordinador"
              rules={[{ required: true, message: "ingresar Coordinador" }]}
            >
              <Select allowClear>
                {props?.coordinadores?.map((coordinador) => (
                  <Select.Option key={coordinador?.id} value={coordinador?.id}>
                    {coordinador?.first_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Guardar
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
}

export default Editar;